import React from 'react';

const Logo = () => {
	return (
		<div className="xl:mx-auto self-start">
			<img
				src="../img/logo-tm-official.png"
				alt="logo"
				className="max-h-12 max-w-12 mx-auto"
			/>
		</div>
	);
};

export default Logo;
